import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

export default function useAddressInfo() {
  const [address, setAddress] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const subDistricts = await dataProvider.getList("sub-districts", {
          addon: JSON.stringify({ district_id: 1 }),
        });
        const districts = await dataProvider.getList("districts", {
          addon: JSON.stringify({ province_id: 1 }),
        });
        const provinces = await dataProvider.getList("provinces", {});
        const postcodes = await dataProvider.getList("postcodes", {
          addon: JSON.stringify({ sub_district_id: 1 }),
        });
        setAddress({
          subDistricts: subDistricts.data,
          districts: districts.data,
          provinces: provinces.data,
          postcodes: postcodes.data,
        });
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubDistrict = (id) =>
    id ? address.subDistricts.find((sub) => sub.id === id)?.name : "";

  const getDistrict = (id) =>
    id ? address.districts.find((sub) => sub.id === id)?.name : "";

  const getProvince = (id) =>
    id ? address.provinces.find((sub) => sub.id === id)?.name : "";

  const getPostcode = (id) =>
    id ? address.postcodes.find((sub) => sub.id === id)?.code : "";

  return {
    ...address,
    loading,
    error,
    getDistrict,
    getSubDistrict,
    getProvince,
    getPostcode,
  };
}
